<template>
  <div style="padding: 0.22rem">
    <div>
      <div class="left_title">网站协议</div>
      <div class="left_tab" v-for="(item, index) in menuList" @click="selectcheck(item)" :class="clickclikc == item.dictValue ? 'left_tab_select' : ''
        ">
        {{ item.dictLabel }}
      </div>
      <div class="left_title">素材库</div>
      <div class="left_tab" v-for="(item, index) in menuList1" @click="selectcheck(item)" :class="clickclikc == item.dictValue ? 'left_tab_select' : ''
        ">
        {{ item.dictLabel }}
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { Axios } from "../assets/js/ls_com_axios.js";
import { ref, defineProps, onMounted, defineEmits, nextTick } from "vue";
import { ElMessage } from "element-plus";
import { useRouter } from "vue-router";
const router = useRouter();
const clickclikc = ref('')
const menuList = ref([]);
const menuList1 = ref([]);
const props = defineProps({
  left_tabShow: String,
});
onMounted(() => {
  nextTick(() => {
    clickclikc.value = props.left_tabShow ? props.left_tabShow : ''
    init()
  })
})
const init = () => {
  Axios('get', '/system/dict/data/type/sys_notice', {}, false, (res) => {
    if (res.data.code == 200) {
      menuList.value = res.data.data
    } else {
      ElMessage({
        message: res.data.msg,
        type: 'error',
      })
    }
  })
  Axios('get', '/system/dict/data/type/sys_sck', {}, false, (res) => {
    if (res.data.code == 200) {
      menuList1.value = res.data.data
    } else {
      ElMessage({
        message: res.data.msg,
        type: 'error',
      })
    }
  })
}
const emit = defineEmits(['back'])
//直接跳转
const selectcheck = (type: any) => {
  console.log("dianji ", type);
  clickclikc.value = type.dictValue
  emit('back', clickclikc.value)
};
</script>

<style scoped>
.left_title {
  font-size: 0.12rem;
  margin-bottom: 0.2rem;
  color: #86909c;
}

.left_tab {
  font-size: 0.14rem;
  margin-bottom: 0.2rem;
  color: #333333;
  cursor: pointer;
}

.left_tab_select {
  color: #C01A26;
}
</style>
